export const verifyRule = {
  // 常用验证
  mobile: {
    reg: /^1[3|4|5|6|7|8|9][0-9]{9}$/, // ^(861((33|49|53|7[37]|8[019]|99)|(3[012]|45|5[56]|66|7[56]|8[56])|(3[456789]|47|5[012789]78|8[23478]))[0-9]{8}$)|^(?!86)\d+
    // tip: '国家号+手机号，如中国,请输入8613900000000',
    tip: '请输入真实有效的手机号码',
    error: '手机号有误！！！'
    // error: '手机号有误,国家号+手机号'

  },
  username: {
    reg: /^[a-zA-Z_]{1}\w{5,9}$/,
    tip: "大小写字母或'_'开头，6-10个字符",
    error: '用户名有误,大小写字母或\'_\'开头，6-10个字符'
  },
  userPsw: {
    reg: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
    error: '密码需为字母和数字组成的6-18位字符'
  },
  psw: {
    reg: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,24}$/,
    // tip: '6到24位字母和数字组合',
    error: '密码有误,6到24位字母和数字组合',
    tip: '密码须为字母和数字组成的6-24字符'
  },
  repeatPsw: {
    reg: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,24}$/,
    tip: '6到24位字母和数字组合',
    error: '重复密码错误'
  },
  logPsw: {
    reg: /^[0-9A-Za-z]{6,24}$/,
    tip: '密码由6到24位字母和数字组合'
  },
  verifyImg: {
    reg: /^([0-9]){5}$/,
    tip: '5位数字',
    error: '图片验证码有误,5位数字'
  },
  verifyCode: {
    reg: /^([0-9]){4}$/,
    tip: '4位数字',
    error: '手机验证码有误,4位数字'
  },
  fundPsw: {
    reg: /^[a-zA-Z_]{1}\w{7,23}$/,
    tip: "大小写字母或'_'开头，8-24位字符",
    error: '资金密码有误,大小写字母或\'_\'开头，8-24位字符'
  }
};
// 帮助内容
export const listhelp = [
  {
    title: '如何更改会员密码？',
    message: '您登陆账号之后，点击页面上方“个人中心”—“修改登录密码”页面，按照相应的规则进行修改您的账号密码。'
  },
  {
    title: '如何找回会员的密码？',
    message: '请联系在线客服，客服人员会协助您修改相关密码。'  // '在用户登陆的页面点击“忘记密码”，根据提示输入您的账号，按照网站的提示来进行操作；如果您既没有绑定邮箱也没有设置安全问题，
  },
  {
    title: '如何编辑个人资料？',
    message: '您可以点击“个人中心”—“个人资料”按照提示操作进行完善自己的个人资料'
  },
  {
    title: '如何绑定邮箱？',
    message: '目前尚未开放相关功能，正在持续规划中' // '您可以通过“个人中心”—“个人资料”—“绑定邮箱设置”页面，填写自己常用的邮箱，系统会给您要绑定的邮箱中发送一份验证邮件，您只需要再进入您的邮箱，点击相关的链接即可验证邮箱。请注意：这个邮箱一旦绑定不可更改，并且也是您找回密码的重要凭证。'
  },
  {
    title: '如何设置资金密码？',
    message: '您可以通过“个人中心”—“资金密码设置”来进行设置自己的资金密码。再次修改资金密码，需要使用自己原来的资金密码。请注意：您的资金密码是您提现的重要密码，请牢记。'
  },
  {
    title: '什么是取款人姓名，如何进行设置？',
    message: '取款人姓名是您提现的一个重要验证，如果取款人的姓名和您的开户行姓名不一致，将无法进行提款，请谨慎设置。您可以通过“个人中心”“用户名”来进行绑定取款人姓名，一经绑定是无法来进行修改的。'
  },
  {
    title: '如何进行充值？',
    message: '您可以通过点击页面右上方“充值”的页面来进行充值。您可以选择在线支付，快捷充值，银行转账，微信充值以及支付宝充值五种方式来进行对您的账号充值。在线支付和快捷充值，您可以选择相应的网上银行依据系统的引导一步一步的操作，提示操作成功即充值成功。银行转账，您可以根据我们给您提供的银行卡信息，在线下进行汇款，汇款成功之后您在网上填写相关的汇款单信息，填写完成之后，即充值成功。请注意：平台会不定期更换收款人信息，充值请以当前发布收款信息进行转账处理，不要保留原始信息直接转账，否则造成损失平台无法处理哦~'
  },
  {
    title: '如何查看余额？',
    message: '您可以用过网站页面上方“彩票余额”进行查看。'
  },
  {
    title: '如何进行取款？',
    message: '您可以通过点击网站页面右上方“取款”页面查看自己可以进行取款的金额，点击取款系统一步一步的提示来进行账号提现。'
  },
  {
    title: '如果查看交易记录？',
    message: '您可以通过“个人中心”—“游戏记录”查看自己各类型的交易记录。'
  },
  {
    title: '我在哪里可以找到彩票游戏？',
    message: '请您登陆您在金海在线娱乐注册的会员账号后，点击网站首页上方「彩票中心」选择相应的彩票类型进入即可。'
  },
  {
    title: '我想买彩票，有什么要求吗？',
    message: '购买彩票并无特定要求，未满18岁的人士进行博彩属非法行为，在此方面绝对严格执行，用户需为年满18岁的公民并有完全行为能力，您只需拥有金海在线娱乐的会员账号且充值成功后，即可进入彩票页面进行投注。'
  },
  {
    title: '我如何查看各项彩票的开奖时间呢？',
    message: '您在相应彩票的游戏规则中即可查看各项彩票的具体开奖时间。'
  },
  {
    title: '我买的彩票中奖了，我该如何兑奖，如何领奖？',
    message: '金海在线娱乐彩票根据官方开奖结果进行派彩，中奖后系统自动将奖金添加至您的金海在线娱乐会员账号中，您点击网站首页的「取款」即可提取您的奖金。'
  },
  {
    title: '我想查询已开奖的中奖号码，该怎么办？',
    message: '请您登陆您的金海在线娱乐会员账号后，在【彩票中心】中选择任一彩种，「订单记录─游戏记录」即可查看您的中奖号码；或至在用户名下拉式表单点选【订单报表】中选择任一彩种，「订单记录─游戏记录」即可查看您的中奖号码。'
  },
  {
    title: '什么是追号、该如何追号？',
    message: '追号指将一注或一组号码进行两期或两期以上的投注。追号可分为连续追号和间隔追号，连续追号指追号的期数是连续的，间隔追号指追号的期数不连续。当您确认选号后，勾选「我要追号」，选择追号期数，则在后续您选定的几期均对该号码进行投注。同时您也可以选择中奖后停止追号。'
  },
  {
    title: '什么是奖金限额？',
    message: '金海在线娱乐对时时彩单期最高奖金限红为40W元，其余高频彩种单期最高奖金限红为20W元，低频彩种单期最高奖金限红为10W元，如奖金超出相应彩种的最高限红，超出的部分将不做赔付。'
  },
  {
    title: '第三方机构未开奖时，我的投注单会怎么处理？',
    message: '如果是第三方机构不开奖，则会对不开奖的奖期进行撤单返款的处理。'
  },
  {
    title: '如何注册？',
    message: '进入首页，登录部分下方点击“免费注册”按钮即可注册'
  }
];

// 彩票归类
export const objArr = [
  {
    title: '五星',
    rows: [[{
      title: '五星直选',
      columns: [{
        showname: '复式',
        shortname: 'wxzhixfs',
        realname: '[五星_复式]',
        tips: '从万位、千位、百位、十位、个位各选一个号码组成一注。',
        example: '投注方案：23456；<br />开奖号码：23456，<br />',
        help: '从万位、千位、百位、十位、个位中选择一个5位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖。',
        select: {
          layout: [{
            title: '万位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '个位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      },
        {
          showname: '单式',
          shortname: 'wxzhixds',
          realname: '[五星_单式]',
          tips: '手动输入号码，至少输入1个五位数号码组成一注。',
          example: '投注方案：23456； 开奖号码：23456，即中五星直选一等奖',
          help: '手动输入一个5位数号码组成一注，所选号码的万位、千位、百位、十位、个位与开奖号码相同，且顺序一致，即为中奖。',
          textarea: {},
          compress: true
        },
        {
          showname: '组合',
          shortname: 'wxzhixzh',
          realname: '[五星_组合]',
          tips: '从个、十、百、千、万位各选一个号码组成五注。',
          example: '五星组合示例，如购买：4+5+6+7+8，该票共10元，由以下5注：45678(五星)、5678(四星)、678(三星)、78(二星)、8(一星)构成。开奖号码：45678，即可中五星、四星、三星、二星、一星的一等奖各1注。',
          help: '从万位、千位、百位、十位、个位中至少各选一个号码组成1-5星的组合，共五注，所选号码的个位与开奖号码相同，则中1个5等奖；所选号码的个位、十位与开奖号码相同，则中1个5等奖以及1个4等奖，依此类推，最高可中5个奖。',
          select: {
            layout: [{
              title: '万位',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }, {
              title: '千位',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }, {
              title: '百位',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }, {
              title: '十位',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }, {
              title: '个位',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }]
          }
        }]
    }],
      [{
        title: '五星组选',
        columns: [{
          showname: '组选120',
          shortname: 'wxzux120',
          realname: '[五星_组选120]',
          tips: '从0-9中选择5个号码组成一注。',
          example: '投注方案：02568，开奖号码的五个数字只要包含0、2、5、6、8，即可中五星组选120一等奖。',
          help: '从0-9中任意选择5个号码组成一注，所选号码与开奖号码的万位、千位、百位、十位、个位相同，顺序不限，即为中奖。',
          select: {
            layout: [{
              title: '选号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }]
          }
        }, {
          showname: '组选60',
          shortname: 'wxzux60',
          realname: '[五星_组选60]',
          tips: '从“二重号”选择一个号码，“单号”中选择三个号码组成一注。',
          example: '投注方案：二重号：8，单号：0、2、5，只要开奖的5个数字包括 0、2、5、8、8，即可中五星组选60一等奖。',
          help: '选择1个二重号码和3个单号号码组成一注，所选的单号号码与开奖号码相同，且所选二重号码在开奖号码中出现了2次，即为中奖。',
          select: {
            layout: [{
              title: '二重号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }, {
              title: '单　号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }]
          }
        }, {
          showname: '组选30',
          shortname: 'wxzux30',
          realname: '[五星_组选30]',
          tips: '从“二重号”选择两个号码，“单号”中选择一个号码组成一注。',
          example: '投注方案：二重号：2、8，单号：0，只要开奖的5个数字包括 0、2、2、8、8，即可中五星组选30一等奖。',
          help: '选择2个二重号和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选的2个二重号码分别在开奖号码中出现了2次，即为中奖。',
          select: {
            layout: [{
              title: '二重号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }, {
              title: '单　号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }]
          }
        }, {
          showname: '组选20',
          shortname: 'wxzux20',
          realname: '[五星_组选20]',
          tips: '从“三重号”选择一个号码，“单号”中选择两个号码组成一注。',
          example: '投注方案：三重号：8，单号：0、2，只要开奖的5个数字包括 0、2、8、8、8，即可中五星组选20一等奖。',
          help: '选择1个三重号码和2个单号号码组成一注，所选的单号号码与开奖号码相同，且所选三重号码在开奖号码中出现了3次，即为中奖。',
          select: {
            layout: [{
              title: '三重号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }, {
              title: '单　号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }]
          }
        }, {
          showname: '组选10',
          shortname: 'wxzux10',
          realname: '[五星_组选10]',
          tips: '从“三重号”选择一个号码，“二重号”中选择一个号码组成一注。',
          example: '投注方案：三重号：8，二重号：2，只要开奖的5个数字包括 2、2、8、8、8，即可中五星组选10一等奖。',
          help: '选择1个三重号码和1个二重号码，所选三重号码在开奖号码中出现3次，并且所选二重号码在开奖号码中出现了2次，即为中奖。',
          select: {
            layout: [{
              title: '三重号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }, {
              title: '二重号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }]
          }
        }, {
          showname: '组选5',
          shortname: 'wxzux5',
          realname: '[五星_组选5]',
          tips: '从“四重号”选择一个号码，“单号”中选择一个号码组成一注。',
          example: '投注方案：四重号：8，单号：2，只要开奖的5个数字包括 2、8、8、8、8，即可中五星组选5一等奖。',
          help: '选择1个四重号码和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选四重号码在开奖号码中出现了4次，即为中奖。',
          select: {
            layout: [{
              title: '四重号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }, {
              title: '单　号',
              balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              tools: true
            }]
          }
        }]
      }],
      [{
        title: '五星其他',
        columns: [{
          showname: '总和大小单双',
          shortname: 'ssc5x_sumdxds',
          realname: '[总和大小单双]',
          tips: '选择一个号码形态。',
          example: '投注方案：总和大，开奖号码：16568，开奖号码的总和26，即中总和大',
          help: '从四个形态中任意选择1个形态或多个形态组成一注，所选号码形态与开奖号码的总和形态一直，即为中奖。',
          select: {
            layout: [{
              title: '选号',
              balls: ['总和大', '总和小', '总和单', '总和双'],
              cls: 'long'
            }]
          }
        }]
      }]]
  },
  {
    title: '后四',
    rows: [[{
      title: '后四直选',
      columns: [{
        showname: '复式',
        shortname: 'sixzhixfsh',
        realname: '[后四星_复式]',
        tips: '从千位、百位、十位、个位中选择一个4位数号码组成一注',
        example: '投注方案：3456；开奖号码：*3456，即中四星直选。',
        help: '从千位、百位、十位、个位中选择一个4位数号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。',
        select: {
          layout: [{
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '个位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'sixzhixdsh',
        realname: '[后四星_单式]',
        tips: '手动输入号码，至少输入1个四位数号码组成一注。',
        example: '投注方案：3456； 开奖号码：3456，即中四星直选一等奖',
        help: '手动输入一个4位数号码组成一注，所选号码的千位、百位、十位、个位与开奖号码相同，且顺序一致，即为中奖。',
        textarea: {},
        compress: true
      }, {
        showname: '组合',
        shortname: 'sixzhixzhh',
        realname: '[后四星_组合]',
        tips: '在千位，百位，十位，个位任意位置上各选一个号码组成四注',
        example: '投注方案：购买5678，含以下4注：5678(四星)、678(三星)、78(二星)、8(一星)构成<br>开奖号码：45678，即可中四星、三星、二星、一星各1注',
        help: '从千位、百位、十位、个位中至少各选一个号码组成1-4星的组合，共四注，所选号码的个位与开奖号码全部相同，则中1个4等奖；所选号码的个位、十位与开奖号码相同，则中1个4等奖以及1个3等奖，依此类推，最高可中4个奖',
        select: {
          layout: [{
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '个位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }], [{
      title: '后四组选',
      columns: [{
        showname: '组选24',
        shortname: 'sixzux24h',
        realname: '[后四星_组选24]',
        tips: '从0-9中选择4个号码组成一注。',
        example: '投注方案：0568，开奖号码的四个数字只要包含0、5、6、8，即可中四星组选24一等奖。',
        help: '从0-9中任意选择4个号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且顺序不限，即为中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组选12',
        shortname: 'sixzux12h',
        realname: '[后四星_组选12]',
        tips: '从“二重号”选择一个号码，“单号”中选择两个号码组成一注。',
        example: '投注方案：二重号：8，单号：0、6，只要开奖的四个数字包括 0、6、8、8，即可中四星组选12一等奖。',
        help: '选择1个二重号码和2个单号号码组成一注，所选单号号码与开奖号码相同，且所选二重号码在开奖号码中出现了2次，即为中奖。',
        select: {
          layout: [{
            title: '二重号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '单　号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组选6',
        shortname: 'sixzux6h',
        realname: '[后四星_组选6]',
        tips: '从“二重号”选择两个号码组成一注。',
        example: '投注方案：二重号：6、8，只要开奖的四个数字从小到大排列为 6、6、8、8，即可中四星组选6。',
        help: '选择2个二重号码组成一注，所选的2个二重号码在开奖号码中分别出现了2次，即为中奖。',
        select: {
          layout: [{
            title: '二重号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组选4',
        shortname: 'sixzux4h',
        realname: '[后四星_组选4]',
        tips: '从“三重号”选择一个号码，“单号”中选择两个号码组成一注。',
        example: '投注方案：三重号：8，单号：2，只要开奖的四个数字从小到大排列为 2、8、8、8，即可中四星组选4。',
        help: '选择1个三重号码和1个单号号码组成一注，所选单号号码与开奖号码相同，且所选三重号码在开奖号码中出现了3次，即为中奖。',
        select: {
          layout: [{
            title: '三重号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '单　号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }]]
  },
  {
    title: '前四',
    rows: [[{
      title: '前四直选',
      columns: [{
        showname: '复式',
        shortname: 'sixzhixfsq',
        realname: '[前四星_复式]',
        tips: '从万位、千位、百位、十位中选择一个4位数号码组成一注',
        example: '投注方案：3456；开奖号码：3456*，即中四星直选。',
        help: '从万位、千位、百位、十位中选择一个4位数号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。',
        select: {
          layout: [{
            title: '万位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'sixzhixdsq',
        realname: '[前四星_单式]',
        tips: '手动输入号码，至少输入1个四位数号码组成一注。',
        example: '投注方案：3456； 开奖号码：3456，即中四星直选一等奖',
        help: '手动输入一个4位数号码组成一注，所选号码的千位、百位、十位、个位与开奖号码相同，且顺序一致，即为中奖。',
        textarea: {},
        compress: true
      }, {
        showname: '组合',
        shortname: 'sixzhixzhq',
        realname: '[前四星_组合]',
        tips: '在万位、千位、百位、十位任意位置上任意选择1个或1个以上号码。',
        example: '投注方案：1；开奖号码万位：1，即中定位胆万位一等奖。',
        help: '从万位、千位、百位、十位任意位置上至少选择1个以上号码，所选号码与相同位置上的开奖号码一致，即为中奖。',
        select: {
          layout: [{
            title: '万位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }], [{
      title: '前四组选',
      columns: [{
        showname: '组选24',
        shortname: 'sixzux24q',
        realname: '[前四星_组选24]',
        tips: '从0-9中选择4个号码组成一注。',
        example: '投注方案：0568，开奖号码的四个数字只要包含0、5、6、8，即可中四星组选24一等奖。',
        help: '从0-9中任意选择4个号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且顺序不限，即为中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组选12',
        shortname: 'sixzux12q',
        realname: '[前四星_组选12]',
        tips: '从“二重号”选择一个号码，“单号”中选择两个号码组成一注。',
        example: '投注方案：二重号：8，单号：0、6，只要开奖的四个数字包括 0、6、8、8，即可中四星组选12一等奖。',
        help: '选择1个二重号码和2个单号号码组成一注，所选单号号码与开奖号码相同，且所选二重号码在开奖号码中出现了2次，即为中奖。',
        select: {
          layout: [{
            title: '二重号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '单　号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组选6',
        shortname: 'sixzux6q',
        realname: '[前四星_组选6]',
        tips: '从“二重号”选择两个号码组成一注。',
        example: '投注方案：二重号：6、8，只要开奖的四个数字从小到大排列为 6、6、8、8，即可中四星组选6。',
        help: '选择2个二重号码组成一注，所选的2个二重号码在开奖号码中分别出现了2次，即为中奖。',
        select: {
          layout: [{
            title: '二重号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组选4',
        shortname: 'sixzux4q',
        realname: '[前四星_组选4]',
        tips: '从“三重号”选择一个号码，“单号”中选择两个号码组成一注。',
        example: '投注方案：三重号：8，单号：2，只要开奖的四个数字从小到大排列为 2、8、8、8，即可中四星组选4。',
        help: '选择1个三重号码和1个单号号码组成一注，所选单号号码与开奖号码相同，且所选三重号码在开奖号码中出现了3次，即为中奖。',
        select: {
          layout: [{
            title: '三重号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '单　号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }]]
  },
  {
    title: '前三',
    rows: [[{
      title: '前三直选',
      columns: [{
        showname: '复式',
        shortname: 'sxzhixfsq',
        realname: '[前三码_复式]',
        tips: '从万、千、百位各选一个号码组成一注。',
        example: '投注方案：345； 开奖号码：345，即中前三直选一等奖',
        help: '从万位、千位、百位中选择一个3位数号码组成一注，所选号码与开奖号码的前3位相同，且顺序一致，即为中奖。',
        select: {
          layout: [{
            title: '万位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'sxzhixdsq',
        realname: '[前三码_单式]',
        tips: '手动输入号码，至少输入1个三位数号码组成一注。',
        example: '投注方案：345； 开奖号码：345，即中前三直选一等奖',
        help: '手动输入一个3位数号码组成一注，所选号码的万位、千位、百位与开奖号码相同，且顺序一致，即为中奖。',
        textarea: {}
      }, {
        showname: '直选和值',
        shortname: 'sxzhixhzq',
        realname: '[前三码_和值]',
        tips: '从0-27中任意选择1个或1个以上号码',
        example: '投注方案：和值1；开奖号码前三位：001,010,100,即中前三直选一等奖',
        help: '所选数值等于开奖号码的万位、千位、百位三个数字相加之和，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            cls: 'hz',
            tools: true
          }]
        }
      }, {
        showname: '直选跨度',
        shortname: 'ssc_zxkd_qs',
        realname: '[前三码_直选跨度]',
        tips: '从0-9中任意选择1个或1个以上号码',
        example: '投注方案：跨度8；开出的三个数字包括0,8,x，其中x≠9，即可中前三直选；',
        help: '开出的三个数字包括1,9,x，其中x≠0，即可中前三直选跨度。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            cls: 'kd',
            tools: true
          }]
        }
      }]
    }], [{
      title: '前三组选',
      columns: [{
        showname: '组三',
        shortname: 'sxzuxzsq',
        realname: '[前三码_组三]',
        tips: '从0-9中任意选择2个或2个以上号码。',
        example: '投注方案：5,8,8；开奖号码前三位：1个5，2个8 (顺序不限)，即中前三组选三一等奖。',
        help: '从0-9中选择2个数字组成两注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖。',
        select: {
          layout: [{
            title: '组三',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组六',
        shortname: 'sxzuxzlq',
        realname: '[前三码_组六]',
        tips: '从0-9中任意选择3个或3个以上号码。',
        example: '投注方案：2,5,8；开奖号码前三位：1个2、1个5、1个8 (顺序不限)，即中前三组选六一等奖。',
        help: '从0-9中任意选择3个号码组成一注，所选号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖。',
        select: {
          layout: [{
            title: '组六',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '混合组选',
        shortname: 'sxhhzxq',
        realname: '[前三码_混合组选]',
        tips: '手动输入号码，至少输入1个三位数号码。',
        example: '投注方案：分別投注(0,0,1),以及(1,2,3)，开奖号码前三位包括：(1)0,0,1，顺序不限，即中得组三一等奖；或者(2)1,2,3，顺序不限，即中得组六一等奖。',
        help: '键盘手动输入购买号码，3个数字为一注，开奖号码的万位、千位、百位符合后三组三或组六均为中奖。',
        textarea: {}
      }, {
        showname: '组选和值',
        shortname: 'qsm_zux_hz',
        realname: '[前三码_和值]',
        tips: '从1-26中任意选择1个或1个以上号码',
        example: '投注方案：和值1；开奖号码前三位：001,010,100,即中前三组选和值',
        help: '所选数值等于开奖号码的万位、千位、百位三个数字相加之和，即为中奖。',
        select: {
          layout: [{
            balls: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
            cls: 'hz',
            tools: true
          }]
        }
      }, {
        showname: '组选包胆',
        shortname: 'ssc_zuxbd_qs',
        realname: '[前三码_组选包胆]',
        tips: '从0-9中任选1个号码。',
        example: '投注方案：包胆3；开奖号码前三位：(1)出现3xx或者33x,即中前三组三；(2)出现3xy，即中前三组六。',
        help: '从0-9中任意选择1个号码组成一注，出现前三组三或组六，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            only: true
          }]
        }
      }]
    }], [{
      title: '前三其他',
      columns: [{
        showname: '特殊号',
        shortname: 'ssctesh_qs',
        realname: '[前三码_特殊号]',
        tips: '从下方中任意选择1个或1个以上号码形态。',
        example: '投注方案：豹子，开奖号码：000xx，即中豹子；投注方案：顺子，开奖号码：123xx，即中顺子；投注方案：对子，开奖号码：001xx，即中对子；投注方案：半顺，开奖号码：124xx，即中半顺；投注方案：杂六，开奖号码：158xx，即中杂六',
        help: '从下方中选择1个号码形态组成1注，所选号码形态与开奖号码的形态相同，且顺序不限，即为中奖。',
        select: {
          layout: [{
            balls: ['豹子', '顺子', '对子', '半顺', '杂六']
          }]
        }
      }, {
        showname: '和值尾数',
        shortname: 'sschzws_qs',
        realname: '[前三码_和值尾数]',
        tips: '从0-9中选择1个号码。',
        example: '投注方案：和值尾数8，；开奖号码：前三位和值尾数为8，即中得和值尾数。',
        help: '从下方中选择1个号码组成1注，所选号码与开奖号码前三位和值的尾数相同，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }]]
  },
  {
    title: '中三',
    rows: [[{
      title: '中三直选',
      columns: [{
        showname: '复式',
        shortname: 'sxzhixfsz',
        realname: '[中三码_复式]',
        tips: '从千、百、十位各选一个号码组成一注。',
        example: '投注方案：456； 开奖号码：456，即中中三直选一等奖',
        help: '从千位、百位、十位中选择一个3位数号码组成一注，所选号码与开奖号码的中间3位相同，且顺序一致，即为中奖。',
        select: {
          layout: [{
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'sxzhixdsz',
        realname: '[中三码_单式]',
        tips: '手动输入号码，至少输入1个三位数号码组成一注。',
        example: '投注方案：345； 开奖号码：2345，即中中三直选一等奖',
        help: '手动输入一个3位数号码组成一注，所选号码的千位、百位、十位与开奖号码相同，且顺序一致，即为中奖。',
        textarea: {}
      }, {
        showname: '直选和值',
        shortname: 'sxzhixhzz',
        realname: '[中三码_和值]',
        tips: '从0-27中任意选择1个或1个以上号码',
        example: '投注方案：和值1；开奖号码中间三位：01001,00010,00100,即中中三直选一等奖',
        help: '所选数值等于开奖号码的千位、百位、十位三个数字相加之和，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            cls: 'hz',
            tools: true
          }]
        }
      }, {
        showname: '直选跨度',
        shortname: 'ssc_zxkd_zs',
        realname: '[中三码_直选跨度]',
        tips: '从0-9中任意选择1个或1个以上号码',
        example: '投注方案：跨度8；开出的三个数字包括0,8,x，其中x≠9，即可中 中三直选；',
        help: '开出的三个数字包括1,9,x，其中x≠0，即可中 中三直选跨度。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            cls: 'kd',
            tools: true
          }]
        }
      }]
    }], [{
      title: '中三组选',
      columns: [{
        showname: '组三',
        shortname: 'sxzuxzsz',
        realname: '[中三码_组三]',
        tips: '从0-9中任意选择2个或2个以上号码。',
        example: '投注方案：5,8,8；开奖号码中间三位：1个5，2个8 (顺序不限)，即中中三组选三一等奖。',
        help: '从0-9中选择2个数字组成两注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖。',
        select: {
          layout: [{
            title: '组三',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组六',
        shortname: 'sxzuxzlz',
        realname: '[中三码_组六]',
        tips: '从0-9中任意选择3个或3个以上号码。',
        example: '投注方案：2,5,8；开奖号码中间三位：1个2、1个5、1个8 (顺序不限)，即中中三组选六一等奖。',
        help: '从0-9中任意选择3个号码组成一注，所选号码与开奖号码的千位、百位、十位相同，顺序不限，即为中奖。',
        select: {
          layout: [{
            title: '组六',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '混合组选',
        shortname: 'sxhhzxz',
        realname: '[中三码_混合组选]',
        tips: '手动输入号码，至少输入1个三位数号码。',
        example: '投注方案：分別投注(0,0,1),以及(1,2,3)，开奖号码中间三位包括：(1)0,0,1，顺序不限，即中得组三一等奖；或者(2)1,2,3，顺序不限，即中得组六一等奖。',
        help: '键盘手动输入购买号码，3个数字为一注，开奖号码的千位、百位、十位符合中三组三或组六均为中奖。',
        textarea: {}
      }, {
        showname: '组选和值',
        shortname: 'zsm_zux_hz',
        realname: '[中三码_和值]',
        tips: '从1-26中任意选择1个或1个以上号码',
        example: '投注方案：和值1；开奖号码中间三位：001,010,100,即中 中三组选和值',
        help: '所选数值等于开奖号码的千位、百位、十位三个数字相加之和，即为中奖。',
        select: {
          layout: [{
            balls: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
            cls: 'hz',
            tools: true
          }]
        }
      }, {
        showname: '组选包胆',
        shortname: 'ssc_zuxbd_zs',
        realname: '[前三码_组选包胆]',
        tips: '从0-9中任选1个号码。',
        example: '投注方案：包胆3；开奖号码中间三位：(1)出现3xx或者33x,即中 中三组三；(2)出现3xy，即中 中三组六。',
        help: '从0-9中任意选择1个号码组成一注，出现中三组三或组六，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            only: true
          }]
        }
      }]
    }], [{
      title: '中三其他',
      columns: [{
        showname: '特殊号',
        shortname: 'ssctesh_zs',
        realname: '[中三码_特殊号]',
        tips: '从下方中任意选择1个或1个以上号码形态。',
        example: '投注方案：豹子<br>开奖号码：x000x，即中豹子<br>投注方案：顺子<br>开奖号码：x123x，即中顺子<br>投注方案：对子<br>开奖号码：x001x，即中对子<br>投注方案：半顺<br>开奖号码：x124x，即中半顺<br>投注方案：杂六<br>开奖号码：x158x，即中杂六',
        help: '所选的号码特殊属性和开奖号码中3位的属性一致，即为中奖<br>1、豹子号指的是三位数字全部相同<br>2、顺子号指的是三位数字呈现连号状态（顺序不限）<br>3、对子号指的是三位数字中有任两码为相同号<br>4、半顺号指的是三位数字中，有两个号码呈现连号状态（顺序不限）<br>5、杂六号指的是三位数字中，状态非豹子号、顺子号、对子号、半顺号，即为杂六',
        select: {
          layout: [{
            balls: ['豹子', '顺子', '对子', '半顺', '杂六']
          }]
        }
      }, {
        showname: '和值尾数',
        shortname: 'sschzws_zs',
        realname: '[中三码_和值尾数]',
        tips: '从0-9中选择1个号码。',
        example: '投注方案：和值尾数8，；开奖号码：中间三位和值尾数为8，即中得和值尾数。',
        help: '从下方中选择1个号码组成1注，所选号码与开奖号码中三位和值的尾数相同，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }]]
  },
  {
    title: '后三',
    rows: [[{
      title: '后三直选',
      columns: [{
        showname: '复式',
        shortname: 'sxzhixfsh',
        realname: '[后三码_复式]',
        tips: '从百位、十位、个位各选一个号码组成一注。',
        example: '投注方案：345；<br>投注方案：345；<br>即中后三直选一等奖',
        help: '从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖。',
        select: {
          layout: [{
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '个位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'sxzhixdsh',
        realname: '[后三码_单式]',
        tips: '手动输入号码，至少输入1个三位数号码组成一注。',
        example: '投注方案：345； 开奖号码：345，即中后三直选一等奖',
        help: '手动输入一个3位数号码组成一注，所选号码的百位、十位、个位与开奖号码相同，且顺序一致，即为中奖。',
        textarea: {}
      }, {
        showname: '直选和值',
        shortname: 'sxzhixhzh',
        realname: '[后三码_和值]',
        tips: '从0-27中任意选择1个或1个以上号码',
        example: '投注方案：和值1；开奖号码后三位：001,010,100,即中后三直选一等奖',
        help: '所选数值等于开奖号码的百位、十位、个位三个数字相加之和，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            cls: 'hz',
            tools: true
          }]
        }
      }, {
        showname: '直选跨度',
        shortname: 'ssc_zxkd_hs',
        realname: '[后三码_直选跨度]',
        tips: '从0-9中任意选择1个或1个以上号码',
        example: '投注方案：跨度8；开出的三个数字包括0,8,x，其中x≠9，即可中后三直选；',
        help: '开出的三个数字包括1,9,x，其中x≠0，即可中后三直选跨度。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            cls: 'kd',
            tools: true
          }]
        }
      }]
    }], [{
      title: '后三组选',
      columns: [{
        showname: '组三',
        shortname: 'sxzuxzsh',
        realname: '[后三码_组三]',
        tips: '从0-9中任意选择2个或2个以上号码。',
        example: '投注方案：5,8,8；开奖号码后三位：1个5，2个8 (顺序不限)，即中后三组选三一等奖。',
        help: '从0-9中选择2个数字组成两注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖。',
        select: {
          layout: [{
            title: '组三',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组六',
        shortname: 'sxzuxzlh',
        realname: '[后三码_组六]',
        tips: '从0-9中任意选择3个或3个以上号码。',
        example: '投注方案：2,5,8；开奖号码后三位：1个2、1个5、1个8 (顺序不限)，即中后三组选六一等奖。',
        help: '从0-9中任意选择3个号码组成一注，所选号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖。',
        select: {
          layout: [{
            title: '组六',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '混合组选',
        shortname: 'sxhhzxh',
        realname: '[后三码_混合组选]',
        tips: '手动输入号码，至少输入1个三位数号码。',
        example: '投注方案：分別投注(0,0,1),以及(1,2,3)，开奖号码后三位包括：(1)0,0,1，顺序不限，即中得组三一等奖；或者(2)1,2,3，顺序不限，即中得组六一等奖。',
        help: '键盘手动输入购买号码，3个数字为一注，开奖号码的百位、十位、个位符合后三组三或组六均为中奖。',
        textarea: {}
      }, {
        showname: '组选和值',
        shortname: 'hsm_zux_hz',
        realname: '[后三码_和值]',
        tips: '从1-26中任意选择1个或1个以上号码',
        example: '投注方案：和值1；开奖号码后三位：001,010,100,即中后三组选和值',
        help: '所选数值等于开奖号码的百位、十位、个位三个数字相加之和，即为中奖。',
        select: {
          layout: [{
            balls: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
            cls: 'hz',
            tools: true
          }]
        }
      }, {
        showname: '组选包胆',
        shortname: 'ssc_zuxbd_hs',
        realname: '[后三码_组选包胆]',
        tips: '从0-9中任选1个号码。',
        example: '投注方案：包胆3；开奖号码后三位：(1)出现3xx或者33x,即中后三组三；(2)出现3xy，即中后三组六。',
        help: '从0-9中任意选择1个号码组成一注，出现后三组三或组六，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            only: true
          }]
        }
      }]
    }], [{
      title: '后三其他',
      columns: [{
        showname: '特殊号',
        shortname: 'ssctesh_hs',
        realname: '[后三码_特殊号]',
        tips: '从下方中任意选择1个或1个以上号码形态。',
        example: '投注方案：豹子<br>开奖号码：xx000，即中豹子<br>投注方案：顺子<br>开奖号码：xx123，即中顺子<br>投注方案：对子<br>开奖号码：xx001，即中对子<br>投注方案：半顺<br>开奖号码：xx124，即中半顺<br>投注方案：杂六<br>开奖号码：xx158，即中杂六',
        help: '所选的号码特殊属性和开奖号码后3位的属性一致，即为中奖<br>1、豹子号指的是三位数字全部相同<br>2、顺子号指的是三位数字呈现连号状态（顺序不限）<br>3、对子号指的是三位数字中有任两码为相同号<br>4、半顺号指的是三位数字中，有两个号码呈现连号状态（顺序不限）<br>5、杂六号指的是三位数字中，状态非豹子号、顺子号、对子号、半顺号，即为杂六',
        select: {
          layout: [{
            balls: ['豹子', '顺子', '对子', '半顺', '杂六']
          }]
        }
      }, {
        showname: '和值尾数',
        shortname: 'sschzws_hs',
        realname: '[后三码_和值尾数]',
        tips: '从0-9中选择1个号码。',
        example: '投注方案：和值尾数8，；开奖号码：后三位和值尾数为8，即中得和值尾数。',
        help: '从下方中选择1个号码组成1注，所选号码与开奖号码后三位和值的尾数相同，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }]]
  },
  {
    title: '二星',
    rows: [[{
      title: '后二星　直选',
      columns: [{
        showname: '复式',
        shortname: 'exzhixfsh',
        realname: '[后二码_直选_复式]',
        tips: '从十、个位各选一个号码组成一注。',
        example: '投注方案：58；开奖号码后二位：58，即中后二直选一等奖。',
        help: '从十位、个位中选择一个2位数号码组成一注，所选号码与开奖号码的十位、个位相同，且顺序一致，即为中奖。',
        select: {
          layout: [{
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '个位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'exzhixdsh',
        realname: '[后二码_直选_单式]',
        tips: '手动输入号码，至少输入1个两位数号码。',
        example: '投注方案：58；开奖号码后二位：58，即中后二直选一等奖。',
        help: '手动输入一个2位数号码组成一注，所选号码的十位、个位与开奖号码相同，且顺序一致，即为中奖。',
        textarea: {}
      }, {
        showname: '直选和值',
        shortname: 'exzhixhzh',
        realname: '[后二码_直选_和值]',
        tips: '从0-18中任意选择1个或1个以上的和值号码。',
        example: '投注方案：和值1；开奖号码后二位：01,10，即中后二直选。',
        help: '所选数值等于开奖号码的十位、个位二个数字相加之和，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
            cls: 'hz',
            tools: true
          }]
        }
      }, {
        showname: '大小单双',
        shortname: 'dxdsh',
        realname: '[后二星_大小单双]',
        tips: '从十位、个位中的“大、小、单、双”中至少各选一个组成一注。',
        example: '投注方案：大单；开奖号码十位与个位：大单，即中后二大小单双一等奖。',
        help: '对十位和个位的“大（56789）小（01234）、单（13579）双（02468）”形态进行购买，所选号码的位置、形态与开奖号码的位置、形态相同，即为中奖。',
        select: {
          layout: [{
            title: '十位',
            balls: ['大', '小', '单', '双']
          }, {
            title: '个位',
            balls: ['大', '小', '单', '双']
          }]
        }
      }, {
        showname: '跨度',
        shortname: 'ssc_zxkd_her',
        realname: '[后二星_大小单双]',
        tips: '从0-9中选择1个号码。',
        example: '投注方案：跨度9；开奖号码为-,-,-,9,0或-,-,-,0,9，即中后二直选跨度。',
        help: '所选数值等于开奖号码的后2位最大与最小数字相减之差，即为中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            cls: 'kd',
            tools: true
          }]
        }
      }]
    }, {
      title: '组选',
      columns: [{
        showname: '复式',
        shortname: 'exzuxfsh',
        realname: '[后二码_组选_复式]',
        tips: '从0-9中任意选择2个或2个以上号码。',
        example: '投注方案：5,8；开奖号码后二位：1个5，1个8 (顺序不限)，即中后二组选一等奖。',
        help: '从0-9中选2个号码组成一注，所选号码与开奖号码的十位、个位相同，顺序不限，即中奖。',
        select: {
          layout: [{
            title: '组选',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'exzuxdsh',
        realname: '[后二码_组选_单式]',
        tips: '手动输入号码，至少输入1个两位数号码。',
        example: '投注方案：5,8；开奖号码后二位：1个5，1个8 (顺序不限)，即中后二组选一等奖。',
        help: '手动输入一个2位数号码组成一注，所选号码的十位、个位与开奖号码相同，顺序不限，即为中奖。',
        textarea: {}
      }, {
        showname: '和值',
        shortname: 'em_zux_hhz',
        realname: '[后二码_组选和值]',
        tips: '从1-17中任意选择1个或1个以上号码。',
        example: '投注方案：和值1；开奖号码后二位：10或01(顺序不限，不含对子号)，即中后二组选。',
        help: '从1-17中任意选择1个或1个以上号码。所选数值等于开奖号码的十位、个位二个数字相加之和（不含对子号），即为中奖。',
        select: {
          layout: [{
            // balls: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18],
            balls: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
            cls: 'hz',
            tools: true
          }]
        }
      }, {
        showname: '包胆',
        shortname: 'ssc_zxbd_her',
        realname: '[后二码_组选_单式]',
        tips: '从0-9中任意选择1个包胆号码。',
        example: '投注方案：包胆号码8；开奖号码后二位：出现1个8（不包括2个8），即中后二组选。',
        help: '从0-9中任意选择1个包胆号码，开奖号码的十位、个位中任意1位包含所选的包胆号码相同（不含对子号），即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            only: true
          }]
        }
      }]
    }], [{
      title: '前二星　直选',
      columns: [{
        showname: '复式',
        shortname: 'exzhixfsq',
        realname: '[前二码_直选_复式]',
        tips: '从万、千位各选一个号码组成一注。',
        example: '投注方案：58；开奖号码前二位：58，即中前二直选一等奖。',
        help: '从万位、千位中选择一个2位数号码组成一注，所选号码与开奖号码的前2位相同，且顺序一致，即为中奖。',
        select: {
          layout: [{
            title: '万位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'exzhixdsq',
        realname: '[前二码_直选_单式]',
        tips: '手动输入号码，至少输入1个两位数号码。',
        example: '投注方案：58；开奖号码前二位：58，即中前二直选一等奖。',
        help: '手动输入一个2位数号码组成一注，所选号码的万位、千位与开奖号码相同，且顺序一致，即为中奖。',
        textarea: {}
      }, {
        showname: '直选和值',
        shortname: 'exzhixhzq',
        realname: '[前二码_直选_和值]',
        tips: '从0-18中任意选择1个或1个以上的和值号码。',
        example: '投注方案：和值1；开奖号码前二位：01,10，即中前二直选。',
        help: '所选数值等于开奖号码的万位、千位二个数字相加之和，即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
            cls: 'hz',
            tools: true
          }]
        }
      }, {
        showname: '大小单双',
        shortname: 'dxdsq',
        realname: '[前二星_大小单双]',
        tips: '从万位、千位中的“大、小、单、双”中至少各选一个组成一注。',
        example: '投注方案：小双；开奖号码万位与千位：小双，即中前二大小单双一等奖。',
        help: '对百位、十位和个位的“大（56789）小（01234）、单（13579）双（02468）”形态进行购买，所选号码的位置、形态与开奖号码的位置、形态相同，即为中奖。',
        select: {
          layout: [{
            title: '万位',
            balls: ['大', '小', '单', '双']
          }, {
            title: '千位',
            balls: ['大', '小', '单', '双']
          }]
        }
      }, {
        showname: '跨度',
        shortname: 'ssc_zxkd_qer',
        realname: '[前二星_大小单双]',
        tips: '从0-9中选择1个号码。',
        example: '投注方案：跨度9；开奖号码为9,0,-,-,-或0,9,-,-,-，即中前二直选跨度。',
        help: '所选数值等于开奖号码的前2位最大与最小数字相减之差，即为中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }, {
      title: '组选',
      columns: [{
        showname: '复式',
        shortname: 'exzuxfsq',
        realname: '[前二码_组选_复式]',
        tips: '从0-9中任意选择2个或2个以上号码。',
        example: '投注方案：5,8；开奖号码前二位：1个5，1个8 (顺序不限)，即中前二组选一等奖。',
        help: '从0-9中选2个号码组成一注，所选号码与开奖号码的万位、千位相同，顺序不限，即中奖。',
        select: {
          layout: [{
            title: '组选',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'exzuxdsq',
        realname: '[前二码_组选_单式]',
        tips: '手动输入号码，至少输入1个两位数号码。',
        example: '投注方案：5,8；开奖号码前二位：1个5，1个8 (顺序不限)，即中前二组选一等奖。',
        help: '手动输入一个2位数号码组成一注，所选号码的万位、千位与开奖号码相同，顺序不限，即为中奖。',
        textarea: {}
      }, {
        showname: '和值',
        shortname: 'em_zux_qhz',
        realname: '[前二码_组选_单式]',
        tips: '从1-17中任意选择1个或1个以上号码。',
        example: '投注方案：和值1；开奖号码前二位：10或01 (顺序不限，不含对子号)，即中前二组选。',
        help: '从1-17中任意选择1个或1个以上号码。所选数值等于开奖号码的万位、千位二个数字相加之和（不含对子号），即为中奖。',
        select: {
          layout: [{
            // balls: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18],
            balls: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
            cls: 'hz',
            tools: true
          }]
        }
      }, {
        showname: '包胆',
        shortname: 'ssc_zxbd_qer',
        realname: '[前二码_组选_单式]',
        tips: '从0-9中任意选择1个包胆号码。',
        example: '投注方案：包胆号码8；开奖号码前二位：出现1个8（不包括2个8），即中前二组选。',
        help: '从0-9中任意选择1个包胆号码，开奖号码的万位、千位中任意1位包含所选的包胆号码相同（不含对子号），即为中奖。',
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            only: true,
            cls: 'bd'
          }]
        }
      }]
    }]]
  },
  {
    title: '定位胆',
    rows: [[{
      title: '定位胆',
      columns: [{
        showname: '定位胆',
        shortname: 'dw',
        realname: '定位胆',
        tips: '在万千百十个位任意位置上任意选择1个或1个以上号码。',
        example: '投注方案：1；开奖号码万位：1，即中定位胆万位一等奖。',
        help: '从万位、千位、百位、十位、个位任意位置上至少选择1个以上号码，所选号码与相同位置上的开奖号码一致，即为中奖。',
        select: {
          layout: [{
            title: '万位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '个位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }]]
  },
  {
    title: '不定胆',
    rows: [[{
      title: '五星不定胆',
      columns: [{
        showname: '一码不定位',
        shortname: 'bdd_bdd_wx1',
        realname: '[不定胆_五星一码]',
        tips: '从0-9中任意选择1个以上号码。',
        example: '投注方案：1；开奖号码至少出现1个1，即中五星一码不定位一等奖。',
        help: '从0-9中选择1个号码，每注由1个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的1个号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '二码不定位',
        shortname: 'bdd_bdd_wx2',
        realname: '[不定胆_五星二码]',
        tips: '从0-9中任意选择2个以上号码。',
        example: '投注方案：1,2；<br>开奖号码：至少出现1和2各1个，即中五星二码不定位。',
        help: '从0-9中选择2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的2个号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '三码不定位',
        shortname: 'bdd_bdd_wx3',
        realname: '[不定胆_五星三码]',
        tips: '从0-9中任意选择3个以上号码。',
        example: '投注方案：1,2,3；<br>开奖号码：至少出现1、2、3各1个，即中五星三码不定位。',
        help: '从0-9中选择3个号码，每注由3个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的3个号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }], [{
      title: '前四不定胆',
      columns: [{
        showname: '一码不定位',
        shortname: 'bdd_bdd_qsix1',
        realname: '[不定胆_前四星一码]',
        tips: '从0-9中任意选择1个以上号码。',
        example: '投注方案：1；<br>开奖号码前四位：至少出现1个1，即中前四星一码不定位。',
        help: '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位中包含所选号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '二码不定位',
        shortname: 'bdd_bdd_qsix2',
        realname: '[不定胆_前四星二码]',
        tips: '从0-9中任意选择2个以上号码。',
        example: '投注方案：1,2；<br>开奖号码前四位：至少出现1和2各1个，即中前四星二码不定位。',
        help: '从0-9中选择2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位中同时包含所选的2个号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }], [{
      title: '后四不定胆',
      columns: [{
        showname: '一码不定位',
        shortname: 'bdd_bdd_hsix1',
        realname: '[不定胆_后四星一码]',
        tips: '从0-9中任意选择1个以上号码。',
        example: '投注方案：1；<br>开奖号码后四位：至少出现1个1，即中后四星一码不定位。',
        help: '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的千位、百位、十位、个位中包含所选号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '二码不定位',
        shortname: 'bdd_bdd_hsix2',
        realname: '[不定胆_后四二码]',
        tips: '从0-9中任意选择2个以上号码。',
        example: '投注方案：1,2；<br>开奖号码后四位：至少出现1和2各1个，即中后四星二码不定位。',
        help: '从0-9中选择2个号码，每注由2个不同的号码组成，开奖号码的千位、百位、十位、个位中同时包含所选的2个号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }], [{
      title: '三星不定胆一码',
      columns: [{
        showname: '后三',
        shortname: 'bdw1mh',
        realname: '[不定胆_后三一码]',
        tips: '从0-9中任意选择1个以上号码。',
        example: '投注方案：1；<br>开奖号码后三位：至少出现1个1，即中后三一码不定位。',
        help: '从0-9中选择1个号码，每注由1个不同的号码组成，开奖号码的百位、十位、个位中同时包含所选的1个号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '中三',
        shortname: 'bdw1mz',
        realname: '[不定胆_中三一码]',
        tips: '从0-9中任意选择1个以上号码。',
        example: '投注方案：1；<br>开奖号码中三位：至少出现1个1，即中 中三一码不定位。',
        help: '从0-9中选择1个号码，每注由1个不同的号码组成，开奖号码的百位、十位、个位中同时包含所选的1个号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '前三',
        shortname: 'bdw1mq',
        realname: '[不定胆_前三一码]',
        tips: '从0-9中任意选择1个以上号码。',
        example: '投注方案：1；<br>开奖号码前三位：至少出现1个1，即中前三一码不定位。',
        help: '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }], [{
      title: '三星不定胆二码',
      columns: [{
        showname: '后三',
        shortname: 'bdw2mh',
        realname: '[不定胆_后三二码]',
        tips: '从0-9中任意选择2个以上号码。',
        example: '投注方案：1,2；<br>开奖号码后三位：至少出现1和2各1个，即中后三二码不定位。',
        help: '从0-9中选择2个号码，每注由2个不同的号码组成，开奖号码的百位、十位、个位中同时包含所选的2个号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '中三',
        shortname: 'bdw2mz',
        realname: '[不定胆_中三二码]',
        tips: '从0-9中任意选择2个以上号码。',
        example: '投注方案：1,2；<br>开奖号码前三位：至少出现1和2各1个，即中 中三二码不定位。',
        help: '从0-9中选择2个号码，每注由2个不同的号码组成，开奖号码的百位、十位、个位中同时包含所选的2个号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '前三',
        shortname: 'bdw2mq',
        realname: '[不定胆_前三二码]',
        tips: '从0-9中任意选择2个以上号码。',
        example: '投注方案：1,2；<br>开奖号码前三位：至少出现1和2各1个，即中前三二码不定位。',
        help: '从0-9中选择2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位中同时包含所选的2个号码，即为中奖。',
        select: {
          layout: [{
            title: '不定胆',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }]]
  },
  {
    title: '任选',
    rows: [[{
      title: '任二',
      columns: [{
        showname: '复式',
        shortname: 'rx2fs',
        realname: '[任选二_复试]',
        tips: '万、千、百、十、个任意2位，开奖号分别对应且顺序一致即中奖',
        example: '万位买0，千位买1，百万买2，开奖01234，则中奖。',
        help: '从万、千、百、十、个中至少2个位置各选一个或多个号码，将各个位置的号码进行组合，所选号码的各位与开奖号码相同则中奖。',
        select: {
          layout: [{
            title: '万位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '个位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'rx2ds',
        realname: '[任选二_单式]',
        tips: '手动输入号码，至少输入1个两位数号码和至少选择两个位置',
        example: '输入号码01并选择万、千位置位，如开奖号码位01***； 则中奖',
        help: '手动输入一注或者多注的两个号码和至少两个位置，如果选中的号码与位置和开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位']
          }]
        },
        textarea: {}
      }, {
        showname: '组选',
        shortname: 'rx2zx',
        realname: '[任选二_组选]',
        tips: '从0-9中任意选择2个或2个以上号码和任意两个位置',
        example: '位置选择万、千，号码选择01；开奖号码为01***、则中奖',
        help: '从0-9中任意选择2个或2个以上号码和万、千、百、十、个任意的两个位置，如果组合的号码与开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位']
          }]
        },
        select: {
          layout: [{
            title: '号码',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '直选和值',
        shortname: 'rx2_zx_hz',
        realname: '[任选二_直选和值]',
        tips: '从0-9中任意选择2个或2个以上号码和任意两个位置',
        example: '位置选择万、千，号码选择01；开奖号码为01***、则中奖',
        help: '从0-9中任意选择2个或2个以上号码和万、千、百、十、个任意的两个位置，如果组合的号码与开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位'],
            chk: [0, 0, 0, 1, 1]
          }]
        },
        select: {
          layout: [{
            title: '号码',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
            tools: true
          }]
        }
      }, {
        showname: '组选和值',
        shortname: 'rx2_zux_hz',
        realname: '[任选二_组选和值]',
        tips: '从0-9中任意选择2个或2个以上号码和任意两个位置',
        example: '位置选择万、千，号码选择01；开奖号码为01***、则中奖',
        help: '从0-9中任意选择2个或2个以上号码和万、千、百、十、个任意的两个位置，如果组合的号码与开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位']
          }]
        },
        select: {
          layout: [{
            title: '号码',
            balls: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
            tools: true
          }]
        }
      }]
    }], [{
      title: '任三',
      columns: [{
        showname: '复式',
        shortname: 'rx3fs',
        realname: '[任选三_复式]',
        tips: '万、千、百、十、个任意3位，开奖号分别对应且顺序一致即中奖',
        example: '万位买0，千位买1，百万买2，十位买3，开奖01234，则中奖。',
        help: '从万、千、百、十、个中至少3个位置各选一个或多个号码，将各个位置的号码进行组合，所选号码的各位与开奖号码相同则中奖。',
        select: {
          layout: [{
            title: '万位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '个位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'rx3ds',
        realname: '[任选三_单式]',
        tips: '手动输入号码，至少输入1个三位数号码和至少选择三个位置',
        example: '输入号码012选择万、千、百位置，如开奖号码位012**； 则中奖',
        help: '手动输入一注或者多注的三个号码和至少三个位置，如果选中的号码与位置和开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位']
          }]
        },
        textarea: {}
      }, {
        showname: '组三',
        shortname: 'rx3z3',
        realname: '[任选三_组三]',
        tips: '从0-9中任意选择2个或2个以上号码和任意三个位置',
        example: '位置选择万、千、百，号码选择01；开奖号码为110**、则中奖',
        help: '从0-9中任意选择2个或2个以上号码和万、千、百、十、个任意的三个位置，如果组合的号码与开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位']
          }]
        },
        select: {
          layout: [{
            title: '号码',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组六',
        shortname: 'rx3z6',
        realname: '[任选三_组六]',
        tips: '从0-9中任意选择3个或3个以上号码和任意三个位置',
        example: '位置选择万、千、百，号码选择012；开奖号码为012**、则中奖',
        help: '从0-9中任意选择3个或3个以上号码和万、千、百、十、个任意的三个位置，如果组合的号码与开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位']
          }]
        },
        select: {
          layout: [{
            title: '号码',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '混合组选',
        shortname: 'rx3hh',
        realname: '[任选三_混合组选]',
        tips: '手动输入号码，至少输入1个三位数号码和任意三个位置',
        example: '投注方案：345； 选择对应位：百、十、个，开奖号码：**345，即为中奖',
        help: '3个数字为一注，所选开奖号码符合对应所选位置的组三或组六均为中奖。',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位']
          }]
        },
        textarea: {}
      }, {
        showname: '直选和值',
        shortname: 'rx3_zx_hz',
        realname: '[任选三_直选和值]',
        tips: '从0-9中任意选择2个或2个以上号码和任意两个位置',
        example: '位置选择万、千，号码选择01；开奖号码为01***、则中奖',
        help: '从0-9中任意选择3个或3个以上号码和万、千、百、十、个任意的三个位置，如果组合的号码与开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位'],
            chk: [0, 0, 0, 1, 1]
          }]
        },
        select: {
          layout: [{
            title: '号码',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
            cls: 'toolong',
            tools: true
          }]
        }
      }, {
        showname: '组选和值',
        shortname: 'rx3_zux_hz',
        realname: '[任选三_组选和值]',
        tips: '从0-9中任意选择3个或3个以上号码和任意三个位置',
        example: '位置选择万、千，号码选择01；开奖号码为01***、则中奖',
        help: '从0-9中任意选择3个或3个以上号码和万、千、百、十、个任意的三个位置，如果组合的号码与开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位']
          }]
        },
        select: {
          layout: [{
            title: '号码',
            balls: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
            tools: true
          }]
        }
      }]
    }], [{
      title: '任四',
      columns: [{
        showname: '复式',
        shortname: 'rx4fs',
        realname: '[任选四_复试]',
        tips: '万、千、百、十、个任意4位，开奖号分别对应且顺序一致即中奖',
        example: '万位买0，千位买1，百万买2，十位买3，个位买4，开奖01234，则中奖。',
        help: '从万、千、百、十、个中至少4个位置各选一个或多个号码，将各个位置的号码进行组合，所选号码的各位与开奖号码相同则中奖。',
        select: {
          layout: [{
            title: '万位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '千位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '百位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '十位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '个位',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '单式',
        shortname: 'rx4ds',
        realname: '[任选四_单式]',
        tips: '手动输入号码，至少输入1个四位数号码和至少选择四个位置',
        example: '输入号码0123选择万、千、百、十位置，如开奖号码位0123*； 则中奖',
        help: '手动输入一注或者多注的四个号码和至少四个位置，如果选中的号码与位置和开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位']
          }]
        },
        textarea: {}
      }, {
        showname: '组选24',
        shortname: 'rx4_zux_z24',
        realname: '[任选四_组选24]',
        tips: '手动输入号码，至少输入1个四位数号码和至少选择四个位置',
        example: '输入号码0123选择万、千、百、十位置，如开奖号码位0123*； 则中奖',
        help: '手动输入一注或者多注的四个号码和至少四个位置，如果选中的号码与位置和开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位']
          }]
        },
        select: {
          layout: [{
            title: '号码',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组选12',
        shortname: 'rx4_zux_z12',
        realname: '[任选四_组选12]',
        tips: '手动输入号码，至少输入1个四位数号码和至少选择四个位置',
        example: '输入号码0123选择万、千、百、十位置，如开奖号码位0123*； 则中奖',
        help: '手动输入一注或者多注的四个号码和至少四个位置，如果选中的号码与位置和开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位'],
            chk: [0, 1, 1, 1, 1]
          }]
        },
        select: {
          layout: [{
            title: '二重号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '单　号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组选6',
        shortname: 'rx4_zux_z6',
        realname: '[任选四_组选6]',
        tips: '手动输入号码，至少输入1个四位数号码和至少选择四个位置',
        example: '输入号码0123选择万、千、百、十位置，如开奖号码位0123*； 则中奖',
        help: '手动输入一注或者多注的四个号码和至少四个位置，如果选中的号码与位置和开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位'],
            chk: [0, 1, 1, 1, 1]
          }]
        },
        select: {
          layout: [{
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '组选4',
        shortname: 'rx4_zux_z4',
        realname: '[任选四_组选4]',
        tips: '手动输入号码，至少输入1个四位数号码和至少选择四个位置',
        example: '输入号码0123选择万、千、百、十位置，如开奖号码位0123*； 则中奖',
        help: '手动输入一注或者多注的四个号码和至少四个位置，如果选中的号码与位置和开奖号码对应则中奖',
        checkbox: {
          layout: [{
            title: '位置',
            value: ['万位', '千位', '百位', '十位', '个位'],
            chk: [0, 1, 1, 1, 1]
          }]
        },
        select: {
          layout: [{
            title: '三重号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }, {
            title: '单　号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }]]
  },
  {
    title: '跨度',
    rows: [[{
      title: '跨度',
      columns: [{
        showname: '前三跨度',
        shortname: 'kdqs',
        realname: '跨度_前三',
        tips: '至少选择一个号码组成一注。',
        example: '投注方案：选择5, 等于开奖号前三位2,5,7的最大数7与最小数字2的差值，即为中奖。',
        help: '玩法：选择0-9，若所选号码与开奖号前三位的最大最小数字的差值相等，即中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '中三跨度',
        shortname: 'kdzs',
        realname: '跨度_中三',
        tips: '至少选择一个号码组成一注。',
        example: '投注方案：选择5, 等于开奖号中三位2,5,7的最大数7与最小数字2的差值，即为中奖。',
        help: '玩法：选择0-9，若所选号码与开奖号中三位的最大最小数字的差值相等，即中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '后三跨度',
        shortname: 'kdhs',
        realname: '跨度_后三',
        tips: '至少选择一个号码组成一注。',
        example: '投注方案：选择5, 等于开奖号后三位2,5,7的最大数7与最小数字2的差值，即为中奖。',
        help: '玩法：选择0-9，若所选号码与开奖号后三位的最大最小数字的差值相等，即中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '前二跨度',
        shortname: 'kdqe',
        realname: '跨度_前二',
        tips: '至少选择一个号码组成一注。',
        example: '投注方案：选择5, 等于开奖号前二位2,7的最大数7与最小数字2的差值，即为中奖。',
        help: '玩法：选择0-9，若所选号码与开奖号前二位的最大最小数字的差值相等，即中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '后二跨度',
        shortname: 'kdhe',
        realname: '跨度_后二',
        tips: '至少选择一个号码组成一注。',
        example: '投注方案：选择5, 等于开奖号后二位2,7的最大数7与最小数字2的差值，即为中奖。',
        help: '玩法：选择0-9，若所选号码与开奖号后二位的最大最小数字的差值相等，即中奖。。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }]]
  },
  {
    title: '趣味',
    rows: [[{
      title: '特殊',
      columns: [{
        showname: '一帆风顺',
        shortname: 'qwyffs',
        realname: '[特殊_一帆风顺]',
        tips: '从0-9中任意选择1个以上号码。',
        example: '投注方案：8；开奖号码：至少出现1个8，即中一帆风顺。',
        help: '从0-9中任意选择1个号码组成一注，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '好事成双',
        shortname: 'qwhscs',
        realname: '[特殊_好事成双]',
        tips: '从0-9中任意选择1个以上的二重号码。',
        example: '投注方案：8；开奖号码：至少出现2个8，即中好事成双。',
        help: '从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现2次，即为中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '三星报喜',
        shortname: 'qwsxbx',
        realname: '[特殊_三星报喜]',
        tips: '从0-9中任意选择1个以上的三重号码。',
        example: '投注方案：8；开奖号码：至少出现3个8，即中三星报喜。',
        help: '从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现3次，即为中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }, {
        showname: '四季发财',
        shortname: 'qwsjfc',
        realname: '[特殊_四季发财]',
        tips: '从0-9中任意选择1个以上的四重号码。',
        example: '投注方案：8；开奖号码：至少出现4个8，即中四季发财。',
        help: '从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现4次，即为中奖。',
        select: {
          layout: [{
            title: '选号',
            balls: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            tools: true
          }]
        }
      }]
    }]]
  },
  {
    title: '龙虎',
    rows: [[{
      title: '龙虎',
      columns: [{
        showname: '万千',
        shortname: 'lhwq',
        realname: '[龙虎_万千]',
        tips: '从万位、千位上选择一个形态组成一注。',
        example: '投注方案：龙；开奖号码万位大于千位：龙，即中奖。',
        help: '根据万位、千位号码数值比大小，万位号码大于千位号码为龙，万位号码小于千位号码为虎，号码相同则为和。所选形态与开奖号码形态一致，即为中奖。',
        select: {
          layout: [{
            title: '龙虎',
            balls: ['龙', '虎', '和']
          }]
        }
      }, {
        showname: '万百',
        shortname: 'lhwb',
        realname: '[龙虎_万百]',
        tips: '从万位、百位上选择一个形态组成一注。',
        example: '投注方案：龙；开奖号码万位大于百位：龙，即中奖。',
        help: '根据万位、百位号码数值比大小，万位号码大于百位号码为龙，万位号码小于百位号码为虎，号码相同则为和。所选形态与开奖号码形态一致，即为中奖。',
        select: {
          layout: [{
            title: '龙虎',
            balls: ['龙', '虎', '和']
          }]
        }
      }, {
        showname: '万十',
        shortname: 'lhws',
        realname: '[龙虎_万十]',
        tips: '从万位、十位上选择一个形态组成一注。',
        example: '投注方案：龙；开奖号码万位大于十位：龙，即中奖。',
        help: '根据万位、十位号码数值比大小，万位号码大于十位号码为龙，万位号码小于十位号码为虎，号码相同则为和。所选形态与开奖号码形态一致，即为中奖。',
        select: {
          layout: [{
            title: '龙虎',
            balls: ['龙', '虎', '和']
          }]
        }
      }, {
        showname: '万个',
        shortname: 'lhwg',
        realname: '[龙虎_万个]',
        tips: '从万位、个位上选择一个形态组成一注。',
        example: '投注方案：龙；开奖号码万位大于个位：龙，即中奖。',
        help: '根据万位、个位号码数值比大小，万位号码大于个位号码为龙，万位号码小于个位号码为虎，号码相同则为和。所选形态与开奖号码形态一致，即为中奖。',
        select: {
          layout: [{
            title: '龙虎',
            balls: ['龙', '虎', '和']
          }]
        }
      }, {
        showname: '千百',
        shortname: 'lhqb',
        realname: '[龙虎_千百]',
        tips: '从千位、百位上选择一个形态组成一注。',
        example: '投注方案：龙；开奖号码千位大于百位：龙，即中奖。',
        help: '根据千位、百位号码数值比大小，千位号码大于百位号码为龙，千位号码小于百位号码为虎，号码相同则为和。所选形态与开奖号码形态一致，即为中奖。',
        select: {
          layout: [{
            title: '龙虎',
            balls: ['龙', '虎', '和']
          }]
        }
      }, {
        showname: '千十',
        shortname: 'lhqs',
        realname: '[龙虎_千十]',
        tips: '从千位、十位上选择一个形态组成一注。',
        example: '投注方案：龙；开奖号码千位大于十位：龙，即中奖。',
        help: '根据千位、十位号码数值比大小，千位号码大于十位号码为龙，千位号码小于十位号码为虎，号码相同则为和。所选形态与开奖号码形态一致，即为中奖。',
        select: {
          layout: [{
            title: '龙虎',
            balls: ['龙', '虎', '和']
          }]
        }
      }, {
        showname: '千个',
        shortname: 'lhqg',
        realname: '[龙虎_千个]',
        tips: '从千位、个位上选择一个形态组成一注。',
        example: '投注方案：龙；开奖号码千位大于个位：龙，即中奖。',
        help: '根据千位、个位号码数值比大小，千位号码大于个位号码为龙，千位号码小于个位号码为虎，号码相同则为和。所选形态与开奖号码形态一致，即为中奖。',
        select: {
          layout: [{
            title: '龙虎',
            balls: ['龙', '虎', '和']
          }]
        }
      }, {
        showname: '百十',
        shortname: 'lhbs',
        realname: '[龙虎_百十]',
        tips: '从百位、十位上选择一个形态组成一注。',
        example: '投注方案：龙；开奖号码百位大于十位：龙，即中奖。',
        help: '根据百位、十位号码数值比大小，百位号码大于十位号码为龙，百位号码小于十位号码为虎，号码相同则为和。所选形态与开奖号码形态一致，即为中奖。',
        select: {
          layout: [{
            title: '龙虎',
            balls: ['龙', '虎', '和']
          }]
        }
      }, {
        showname: '百个',
        shortname: 'lhbg',
        realname: '[龙虎_百个]',
        tips: '从百位、个位上选择一个形态组成一注。',
        example: '投注方案：龙；开奖号码百位大于个位：龙，即中奖。',
        help: '根据百位、个位号码数值比大小，百位号码大于个位号码为龙，百位号码小于个位号码为虎，号码相同则为和。所选形态与开奖号码形态一致，即为中奖。',
        select: {
          layout: [{
            title: '龙虎',
            balls: ['龙', '虎', '和']
          }]
        }
      }, {
        showname: '十个',
        shortname: 'lhsg',
        realname: '[龙虎_十个]',
        tips: '从十位、个位上选择一个形态组成一注。',
        example: '投注方案：龙；开奖号码十位大于个位：龙，即中奖。',
        help: '根据十位、个位号码数值比大小，十位号码大于个位号码为龙，十位号码小于个位号码为虎，号码相同则为和。所选形态与开奖号码形态一致，即为中奖。',
        select: {
          layout: [{
            title: '龙虎',
            balls: ['龙', '虎', '和']
          }]
        }
      }]
    }]]
  },
  {
    title: '牛牛',
    placeholder: '敬请期待',
    rows: [[{
      title: '牛牛',
      columns: []
    }]]
  }];



// WEBPACK FOOTER //
// src/js/const.js